<template>
<div>
    <div class="maren-sol">
        <el-container class="d-flex-column">
        <h1>Products</h1>
        <p>Maren solution is a product-based software company <span class="d-block">known for intuitive design and user friendly applications </span> into multiple domains <span class="d-block"></span></p>
        <!-- <a href="javascript:void(0);">Read more</a> -->
        </el-container>
    </div>
    <el-container class="d-flex-column p-t50">
        <h2>Our Products</h2>
      <el-row :gutter="20" class=" p-tb50 d-flex d-flex-center">
        <el-col :span="12">
          <img src="../../../public/img/products/healthcare.svg" class="img-responsive" alt="Healthcare">
        </el-col>
        <el-col :span="12">
            <div>
                <h3>Healthcare</h3>
                <p>The health care industry or medical industry, is a sector that provides 
                   <span class="d-block">services to cure patients with curative, preventive, rehabilitative or palliative care. It is composed of establishments devoted to prevention, diagnosis, treatment, and rehabilitation of medical conditions. </span>  Such treatment may be through providing products or services, and may be provided privately or publicly.</p>
                <!-- <a href="javascript:void(0);">Read more</a> -->
            </div>
        </el-col>
      </el-row>
      <el-row :gutter="20" class=" p-tb50 d-flex d-flex-center">
        <el-col :span="12">
          <h3>E Commerce</h3>
          <p> The existing business scenarios demand flexible, agile applications to meet 
      new imperatives and accelerate core business processes. With E-Business emerging as a major industry,  <span class="d-block">businesses need ‘happening’ E-Commerce solutions to keep up with the competition and establish brand equity in today’s clustered web space. Incorporating a broad range of cutting-edge technologies,</span>        Maren Solutions  delivers measurable value through effective, high-performance Online E-Commerce Solutions.
</p>
          <!-- <a href="javascript:void(0);">Read more</a> -->
        </el-col>
        <el-col :span="12">
          <img src="../../../public/img/products/e-commerce.svg" class="img-responsive" alt="E commerce">
        </el-col>
      </el-row>
      <el-row :gutter="20" class=" p-tb50 d-flex d-flex-center">
        <el-col :span="12">
          <img src="../../../public/img/products/logist.png" class="img-responsive" alt="Healthcare">
        </el-col>
        <el-col :span="12">
            <div>
                <h3>Logistics</h3>
                <p>Our software allows the end users to earn money while they travel 
                and ensures the neccessary requested items are delivered. We have our unique strategic approach which can be considered as the first online platform 
                being user friendly completely. We use the on-going trendy technologies to implement with in comparabale business strategy.</p>
                
            </div>
        </el-col>
      </el-row>
    </el-container>
</div>
</template>
<script>
import { mapState, mapGetters } from "vuex";
  export default {
  watch:{
    scobj:{
      immediate:true,
      deep: true,
      handler(){
        if(this.scobj){
          this.scobj = false
          var element = this.$refs['flightRef'];
          var top = element.offsetTop;
          window.scrollTo(0, top);
        }
      }
    }
  },
    computed: mapState(['currentLanguage']),
    title () {
      return this.currentLanguage == 'en' ? '' : ''
    },
    components:{  },
    data() {
      return {
          scobj: false,
          sobj: {}
        }
      },
        async created() {
    let response = await this.$store.dispatch("FETCH_SSC", this);
localStorage.setItem('FTR', JSON.stringify(response.FTR)),
localStorage.setItem('FTD', JSON.stringify(response.FTD))
  },
      methods: {
        toggleBodyClass(addRemoveClass, className) {
          const el = document.body;

          if (addRemoveClass === 'addClass') {
            el.classList.add(className);
          } else {
            el.classList.remove(className);
          }
        },
      },
        mounted() {
          this.toggleBodyClass('addClass', 'products');
        },
        destroyed() {
          this.toggleBodyClass('removeClass', 'products');
        }
    };
</script>


// WEBPACK FOOTER //
// Products.vue